import React, { FunctionComponent } from 'react';

import { ContextProps } from 'reviews2/feed/review-yeti//Review.types';
import { RepliesProvider } from 'reviews2/feed/review-yeti/Replies.store';
import { ReviewReplies } from 'reviews2/feed/review-yeti/replies/ReviewReplies';
import { useReview } from 'reviews2/feed/review-yeti/Review.store';

export const ReviewRepliesContainer: FunctionComponent<ContextProps> = ({ context }) => {
    const { showReplies } = context.options!;
    const [{ review }] = useReview();

    if (!showReplies) {
        return null;
    }

    return (
        <div className="r4e-review-replies-container">
            <RepliesProvider replies={review?.replies}>
                <ReviewReplies context={context} />
            </RepliesProvider>
        </div>
    );
};
